{
  "v8e.accueil.categorie.confirmer": "I confirm deleting this category.",
  "v8e.accueil.categorie.quoi": "The category",
  "v8e.accueil.categorie.supprimable": "“{{label}}” has no entry: it can be deleted.",
  "v8e.accueil.categorie.supprimee": "Category deleted; the action is recorded in the log.",
  "v8e.accueil.categorie.supprimer": "Delete the category",
  "v8e.accueil.categorie.utilisee": "“{{label}}” is used by {{n}} entry(ies): it stays.",
  "v8e.accueil.code.ACCESS_REQUEST_NOT_PENDING": "This request has already been decided by someone else.",
  "v8e.accueil.code.ACCESS_REQUEST_SELF_DECISION": "You cannot decide your own access request.",
  "v8e.accueil.code.ORGANISATION_DESCRIPTION_TOO_LONG": "The description is at most 2000 characters long.",
  "v8e.accueil.code.ORGANISATION_ID_IMMUTABLE": "An organisation identifier cannot be changed.",
  "v8e.accueil.code.ORGANISATION_NAME_INVALID": "The organisation name must be 2 to 120 characters long.",
  "v8e.accueil.code.ORGANISATION_NOT_FOUND": "Organisation not found.",
  "v8e.accueil.code.ORGANISATION_PROFILE_UNCHANGED": "Nothing to save: name and description unchanged.",
  "v8e.accueil.code.PROFIL_NIVEAU_INCOMPATIBLE": "This profile cannot be granted on a project.",
  "v8e.accueil.code.TECH_CATEGORY_IN_USE": "This category is used by catalogue entries: it stays.",
  "v8e.accueil.code.TECH_CATEGORY_PLATFORM_FLOOR": "This category is a platform floor: it is never deleted.",
  "v8e.accueil.code.WORKSPACE_ARCHIVED": "This project is archived: it no longer accepts members.",
  "v8e.accueil.compteur.approbations": "Pending approvals",
  "v8e.accueil.compteur.archives": "archived",
  "v8e.accueil.compteur.documents": "Ingested documents",
  "v8e.accueil.compteur.membres": "Members",
  "v8e.accueil.compteur.palier": "Plan",
  "v8e.accueil.compteur.programmes": "Programmes",
  "v8e.accueil.compteur.projets": "Projects",
  "v8e.accueil.compteur.travaux": "Jobs running or pending",
  "v8e.accueil.decider.titre": "Awaiting a decision",
  "v8e.accueil.decision.approved": "{{objet}} approved by {{qui}} ({{quand}})",
  "v8e.accueil.decision.rejected": "{{objet}} rejected by {{qui}} ({{quand}})",
  "v8e.accueil.demandes.accepter": "Accept",
  "v8e.accueil.demandes.dejaDecidee": "Already decided by someone else.",
  "v8e.accueil.demandes.ligne": "{{qui}} asks to join the project “{{projet}}”",
  "v8e.accueil.demandes.motif": "Reason for refusal (optional)",
  "v8e.accueil.demandes.notifiee": "Decision recorded; the person is notified.",
  "v8e.accueil.demandes.profil": "Profile granted on the project",
  "v8e.accueil.demandes.refuser": "Refuse",
  "v8e.accueil.demandes.titre": "Project access requests",
  "v8e.accueil.demandes.vide": "No access request to decide.",
  "v8e.accueil.etape.activer_les_modeles_d_ia": "Enable AI models",
  "v8e.accueil.etape.ajouter_un_moyen_de_paiement": "Add a payment method",
  "v8e.accueil.etape.choisir_le_palier": "Choose the plan",
  "v8e.accueil.etape.creer_le_premier_projet": "Create the first project",
  "v8e.accueil.etape.inviter_l_equipe": "Invite the team",
  "v8e.accueil.etape.inviter_un_administrateur": "Invite an administrator",
  "v8e.accueil.etape.proposer_les_modeles_d_espace": "Offer workspace templates",
  "v8e.accueil.etape.regler_la_securite_de_connexion": "Set sign-in security",
  "v8e.accueil.etape.renseigner_la_facturation": "Fill in billing details",
  "v8e.accueil.etapeEtat.a_faire": "To do",
  "v8e.accueil.etapeEtat.en_attente": "Awaiting acceptance",
  "v8e.accueil.etapeEtat.fait": "Done",
  "v8e.accueil.etapeEtat.non_disponible": "Not available (wave {{port}})",
  "v8e.accueil.fiche.activationEnAttente": "activation pending",
  "v8e.accueil.fiche.administrateurs": "Who administers the organisation",
  "v8e.accueil.fiche.aucunAdministrateur": "No administrator named: the owner administers.",
  "v8e.accueil.fiche.compteurs": "In figures",
  "v8e.accueil.fiche.derogations": "Waivers",
  "v8e.accueil.fiche.description": "Description",
  "v8e.accueil.fiche.descriptionTropLongue": "At most {{max}} characters.",
  "v8e.accueil.fiche.detailsTechniques": "Technical details",
  "v8e.accueil.fiche.enregistree": "Identity saved.",
  "v8e.accueil.fiche.enregistrer": "Save the identity",
  "v8e.accueil.fiche.gouvernance": "Governance settings",
  "v8e.accueil.fiche.identifiantFige": "The identifier {{id}} is fixed: tokens, links and audit carry it.",
  "v8e.accueil.fiche.identite": "Organisation identity",
  "v8e.accueil.fiche.integrations": "Integrations",
  "v8e.accueil.fiche.nom": "Organisation name",
  "v8e.accueil.fiche.nomInvalide": "{{min}} to {{max}} characters.",
  "v8e.accueil.fiche.onglet.apercu": "Overview",
  "v8e.accueil.fiche.onglet.cles-d-api": "API keys",
  "v8e.accueil.fiche.onglet.integrations-ia": "AI integrations",
  "v8e.accueil.fiche.onglet.propriete-et-cycle-de-vie": "Ownership and lifecycle",
  "v8e.accueil.fiche.onglet.webhooks": "Webhooks",
  "v8e.accueil.fiche.ongletAutreVague": "This tab is delivered by another package of the wave.",
  "v8e.accueil.fiche.onglets": "Organisation record sections",
  "v8e.accueil.fiche.resumeDerogations": "{{aDecider}} to decide, {{accordees}} granted, {{echues}} expired",
  "v8e.accueil.fiche.rien": "Nothing to save.",
  "v8e.accueil.fiche.statut": "Status: {{statut}}",
  "v8e.accueil.ia.arretee": "AI stopped since {{depuis}} by {{par}}: {{motif}}",
  "v8e.accueil.ia.arreteePlateforme": "AI stopped by the platform.",
  "v8e.accueil.ia.arreter": "Stop the organisation’s AI",
  "v8e.accueil.ia.enService": "AI running.",
  "v8e.accueil.ia.relancer": "Restart the organisation’s AI",
  "v8e.accueil.ia.titre": "Organisation AI status",
  "v8e.accueil.invitations.lienATransmettre": "New link created: pass it on yourself.",
  "v8e.accueil.invitations.nouveauLien": "New link",
  "v8e.accueil.lesVotres": "requested by you: someone else decides",
  "v8e.accueil.lien.lien-abonnement-et-facturation": "Subscription and billing",
  "v8e.accueil.lien.lien-confirmer-l-autorisation": "Confirm the authorisation",
  "v8e.accueil.lien.lien-creer-un-projet": "Create a project",
  "v8e.accueil.lien.lien-decider-la-derogation": "Decide the waiver",
  "v8e.accueil.lien.lien-decider-la-finalite": "Decide the purpose",
  "v8e.accueil.lien.lien-decider-le-changement": "Decide the change",
  "v8e.accueil.lien.lien-documents-ingeres": "Ingested documents",
  "v8e.accueil.lien.lien-inviter-une-personne": "Invite someone",
  "v8e.accueil.lien.lien-ouvrir-l-exigence": "Open the requirement",
  "v8e.accueil.lien.lien-ouvrir-le-catalogue": "Open the catalogue",
  "v8e.accueil.lien.lien-ouvrir-le-harnais": "Open the harness",
  "v8e.accueil.lien.lien-ouvrir-le-journal": "Open the log",
  "v8e.accueil.lien.lien-ouvrir-les-connexions-et-modeles": "Connections and models",
  "v8e.accueil.lien.lien-ouvrir-les-validations": "Open validations",
  "v8e.accueil.lien.lien-publier-l-exigence": "Publish the requirement",
  "v8e.accueil.lien.lien-regler-la-gouvernance": "Set governance",
  "v8e.accueil.lien.lien-reprendre-les-premiers-pas": "Resume getting started",
  "v8e.accueil.lien.lien-retour-a-l-accueil": "Back to home",
  "v8e.accueil.lien.lien-valider-la-version-de-charte": "Validate the charter version",
  "v8e.accueil.lien.lien-voir-l-abonnement": "See the subscription",
  "v8e.accueil.lien.lien-voir-la-sante": "See health",
  "v8e.accueil.lien.lien-voir-les-axes": "See the axes",
  "v8e.accueil.lien.lien-voir-les-membres": "See members",
  "v8e.accueil.lien.lien-voir-les-nouvelles-piles": "See new stacks",
  "v8e.accueil.lien.lien-voir-les-projets": "See projects",
  "v8e.accueil.lien.lien-voir-les-suppressions-programmees": "See scheduled deletions",
  "v8e.accueil.ordre.asc": "ascending",
  "v8e.accueil.ordre.desc": "descending",
  "v8e.accueil.premiersPas.afficher": "Show getting started",
  "v8e.accueil.premiersPas.enregistre": "Choice saved for you only.",
  "v8e.accueil.premiersPas.masquer": "Hide getting started",
  "v8e.accueil.premiersPas.masques": "Getting started hidden by you.",
  "v8e.accueil.premiersPas.progression": "{{k}} of {{n}} step(s) done",
  "v8e.accueil.premiersPas.titre": "Getting started",
  "v8e.accueil.profil.administrateur-projet": "Project administrator",
  "v8e.accueil.profil.architecte": "Architect",
  "v8e.accueil.profil.developpeur": "Developer",
  "v8e.accueil.profil.lecteur": "Reader (default)",
  "v8e.accueil.profil.metier-commanditaire": "Business sponsor",
  "v8e.accueil.profil.responsable-mises-en-production": "Release manager",
  "v8e.accueil.profil.responsable-produit": "Product owner",
  "v8e.accueil.profil.scrum-master": "Scrum Master",
  "v8e.accueil.profil.testeur": "Tester",
  "v8e.accueil.raccourcis": "Administration shortcuts",
  "v8e.accueil.section.autorisations_sensibles": "Sensitive authorisations to confirm",
  "v8e.accueil.section.changements": "Technology changes to decide",
  "v8e.accueil.section.derogations": "Waivers to decide",
  "v8e.accueil.section.exigences_a_publier": "Requirements to publish",
  "v8e.accueil.section.exigences_a_valider": "Requirements to validate",
  "v8e.accueil.section.finalites": "AI purposes to decide",
  "v8e.accueil.section.invitations_expirees": "Expired invitations",
  "v8e.accueil.section.nombre": "{{n}} item(s)",
  "v8e.accueil.section.nonDisponible": "Not yet available: delivered with wave {{port}}.",
  "v8e.accueil.section.nouvelles_piles": "Newly qualified stacks",
  "v8e.accueil.section.objets_a_valider": "Objects to validate",
  "v8e.accueil.section.versions_de_charte": "Charter versions to validate",
  "v8e.accueil.statut.active": "active",
  "v8e.accueil.statut.deleting": "deletion scheduled",
  "v8e.accueil.statut.suspended": "suspended (read only)",
  "v8e.accueil.surveiller.connexion": "AI connection unreachable: {{nom}}",
  "v8e.accueil.surveiller.delegation": "Delegation on “{{projet}}” expiring on {{date}}",
  "v8e.accueil.surveiller.droitIsole": "Right {{droit}} of {{personne}} expiring on {{date}}",
  "v8e.accueil.surveiller.mfa": "{{n}} account(s) without a second factor although required",
  "v8e.accueil.surveiller.mfaNonMesure": "Second factor required: account status is shown in the organisation’s security.",
  "v8e.accueil.surveiller.quota": "Quota {{ressource}} of “{{projet}}” at {{pourcentage}}%",
  "v8e.accueil.surveiller.rien": "Nothing to watch.",
  "v8e.accueil.surveiller.suppression": "Deletion of “{{projet}}” scheduled on {{date}}",
  "v8e.accueil.surveiller.titre": "To watch",
  "v8e.accueil.tri.approbations_en_attente": "Pending approvals",
  "v8e.accueil.tri.derniere_activite": "Last activity",
  "v8e.accueil.tri.nom": "Workspace",
  "v8e.accueil.tri.travaux_en_cours": "Running jobs",
  "v8e.accueil.vue.agents": "Available agents",
  "v8e.accueil.vue.archive": "archived: read only",
  "v8e.accueil.vue.archiver": "Archive",
  "v8e.accueil.vue.artefact": "{{titre}} — {{projet}}",
  "v8e.accueil.vue.artefacts": "Latest artefacts",
  "v8e.accueil.vue.aucunEspace": "No workspace.",
  "v8e.accueil.vue.commencer": "Start by creating a first workspace; ideas are then submitted inside the project.",
  "v8e.accueil.vue.compteurs": "Counters",
  "v8e.accueil.vue.creer": "Create a project",
  "v8e.accueil.vue.creerPremier": "Create my first workspace",
  "v8e.accueil.vue.decisions": "Recent decisions",
  "v8e.accueil.vue.espaces": "Workspaces",
  "v8e.accueil.vue.modeles": "Served models",
  "v8e.accueil.vue.nombreAgents": "{{n}} published agent(s)",
  "v8e.accueil.vue.nonAccessibles": "{{n}} project(s) not accessible: counted, never named.",
  "v8e.accueil.vue.ordre": "Order",
  "v8e.accueil.vue.reserveAuxDetenteurs": "The organisation overview is reserved to holders of the “view organisation members” right: the organisation administration and the auditor. Your projects remain in the context selector.",
  "v8e.accueil.vue.sansDescription": "No description",
  "v8e.accueil.vue.sante": "Compliance health",
  "v8e.accueil.vue.santeComptes": "{{bonne}} good, {{a_surveiller}} to watch, {{degradee}} degraded, {{sans_donnee}} without data",
  "v8e.accueil.vue.trierPar": "Sort by"
}
